export const getMe = (id: string) => {
  return [id, 'user']
}

export const getProviderMe = (id: string) => {
  return [id, 'provider']
}
